import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const QuestionCircleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M9.67 7.07c1.29-1.13 3.38-1.13 4.67 0 1.29 1.13 1.29 2.96 0 4.08-.22.2-.47.36-.74.49-.82.4-1.6 1.1-1.6 2.01v.82"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="17.5" r="1" fill={color} />
    </BaseIcon>
  ),
);

QuestionCircleIcon.displayName = 'QuestionCircleIcon';
